// @flow

import React from 'react'

import upIcon from '../../Icons/icon-up.svg'
import downIcon from '../../Icons/icon-down.svg'
import neutralIcon from '../../Icons/icon-neutral.svg'
import Loading from '../../Icons/loading.gif'

import Row from 'michelangelo/dist/Components/Row'
import Column from 'michelangelo/dist/Components/Column'

type Props = {
  loading: boolean,
  title: string,
  newContentPercent: number,
  sinceText: string
}

function AdministratorBlock ({ loading, title, newContentPercent, sinceText }: Props) {
  const percent = `${(newContentPercent * 100).toFixed(0)}%`

  const emptyContentPercent = newContentPercent === null || newContentPercent === undefined

  const LoadingIndicator = () => (<div><img src={Loading} alt='Loading' /></div>)

  return (
    <div className='BlockItem' style={{ flexBasis: '30%' }}>
      <h4>Administrator</h4>
      {loading && <LoadingIndicator />}
      {!loading && (
        <Row>
          <Column classNames={['is-12 is-12-desktop']}>
            <div className='BlockHeaderWrapper'>
              <h3> {title} </h3>
              <h5 className='BlockSubHeader'> New Content </h5>
            </div>
            {emptyContentPercent || newContentPercent === 0
              ? <p><img src={neutralIcon} alt='Neutral' /> {percent} New content {sinceText}</p>
              : newContentPercent > 0
                ? <p><img src={upIcon} alt='Up' /> {percent} New content {sinceText}</p>
                : <p><img src={downIcon} alt='Down' /> {percent} New Content {sinceText}</p>}
          </Column>
        </Row>
      )}
    </div>
  )
}

export default AdministratorBlock
